export function sortEntitiesByType(entities) {
    return [...entities].sort((a, b) => {
        return a.type < b.type ? 1 : -1;
    });
}
//# sourceMappingURL=sort-entities-by-type.js.map